import { useTranslation } from "i18nano";
import React, { useEffect } from "react";
import { useParams } from "react-router-dom";
import { useNotification } from "../../components/UI";
import { useCreateScenarioStore } from "../../stores";
import Chart from "./Chart";
import "./CreateScenarioPage.scss";
import LeftControlPanel from "./LeftControlPanel";
import RightControlPanel from "./RightControlPanel";


const CreateScenarioPage = () => {
    const { getScenario, error, clearStore } = useCreateScenarioStore(state => state);
    const { addNotific } = useNotification();
    const t = useTranslation();

    const params = useParams();

    useEffect(() => {
        return () => {
            clearStore();
        };
    }, []);

    useEffect(() => {
        if (params.scenarioId) {
            getScenario(params.scenarioId);
        }
    }, [params]);

    useEffect(() => {
        if (error) {
            addNotific({
                title: t(error.title),
                body: t(error.body, { ...error.data }),
                type: "danger"
            });
        }
    }, [error]);

    return (
        <div className={"createScenarioContainer"}>
            <LeftControlPanel />
            <div className={"chart-container"} dir={"ltr"}>
                <Chart />
            </div>
            <RightControlPanel />
        </div>
    );
};

export default CreateScenarioPage;